const Config = {
    event: 'JFokus',
    location: 'Stockholm',
    composer: 'ABBA',
};

export default Config;



// WEBPACK FOOTER //
// ./src/js/Config/index.js